var SCM = SCM || {};

SCM.FormWidget = (function ($) {

    return {
        init
    };

    function init() {
        addTextAreaListener();
        addSubmitListener();
        addAriaInvalidHandling();
    }

    function addTextAreaListener() {
        $('.js-form-textarea').on('keyup', updateTextAreaRemainingChars);
    }

    function addSubmitListener() {
        $('.js-widget-dynamic-form').on('submit', submitForm);
    }

    function updateTextAreaRemainingChars() {
        const MaxCharacters = $(this).data('maxLength');
        $(this).parent().find('.js-remaining-characters').text(getCharsRemaining($(this), MaxCharacters));
    }

    function submitForm(event) {
        event.preventDefault();
        const $FormContainer = $('.js-widget-dynamic-form-container');
        const $Form = $('.js-widget-dynamic-form');
        const RecaptchaResponse = $FormContainer.find('#g-recaptcha-response').val();
        const Data = new FormData(this);
        Data.append('CaptchaResponse', RecaptchaResponse);
        const InstanceName = $('#FormInstanceName').val();

        executePost(InstanceName, Data, $Form, $FormContainer);
    }

    function executePost(instanceName, data, $form, $formContainer) {
        SCM.Ajax.post('/Common/DynamicFormSubmit/' + instanceName, data)
            .expectActionResultModel()
            .then(function (result) {
                handleResult(result, $form, $formContainer);
            })
            .catch(console.error);
    }

    function addAriaInvalidHandling() {
        $('input[required]').on('invalid', function () {
            $(this).attr('aria-invalid', 'true');
        });
        $('input[required]').on('input', function () {
            if (this.validity.valid) {
                $(this).removeAttr('aria-invalid');
            }
        });
    }

    function handleResult(result, $form, $formContainer) {
        let errorMsgDiv = $form.find('.js-error-message');

        if (result.Success) {
            let successMsgDiv = $form.find('.message-success');
            let successMsg = $('<div/>');
            $.each(result.Messages,
                function (i, v) {
                    successMsg.append(v);
                });
            $formContainer.addClass('hide');
            errorMsgDiv.addClass('hide');
            successMsgDiv.html(successMsg.html()).show();
            if (SCM.GoogleTagManagerDataLayerEvents) {
                SCM.GoogleTagManagerDataLayerEvents.logSuccessfulContactUs();
            }
        } else if (result.Messages?.length) {
            let ulObj = $('<ul></ul>');
            $.each(result.Messages,
                function (i, v) {
                    ulObj.append('<li>' + v + '</li>');
                });
            errorMsgDiv.html(ulObj).removeClass('hide');
        }
    }

    function getCharsRemaining(target, limit) {
        const Len = $(target).val().length;
        if (Len > limit) {
            $(target).val($(target).val().substring(0, limit));
            return 0;
        } else return (limit - Len).toString();
    }
}) (jQuery);